<template>
  <div class="topbar-item">
    <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
         id="kt_quick_user_toggle">
      <span class="text-muted font-weight-bold font-size-base mr-1">
        {{ $ml.get('hello') }},
      </span>
      <span class="text-dark-50 font-weight-bolder font-size-base mr-3">
        {{ currentUser.user.fullname }}
      </span>
      <span class="symbol symbol-35 symbol-light-success">
        <span class="symbol-label font-size-h5 font-weight-bold">
          {{ currentUser.user.fullname.slice(0, 1).toUpperCase() }}
        </span>
      </span>
    </div>

    <div id="kt_quick_user"
         ref="kt_quick_user"
         class="offcanvas offcanvas-right">
      <!--begin::Header-->
      <div class="offcanvas-header d-flex align-items-center justify-content-between p-5">
        <h3 class="font-weight-bold m-0">
          {{ currentUser.user.fullname }}
        </h3>
        <a href="#"
           class="d-flex btn btn-xs btn-light p-2 rounded-sm"
           id="kt_quick_user_close">
          <i class="far fa-times-circle p-0"></i>
        </a>
      </div>
      <!--end::Header-->
      <div class="separator separator-solid"></div>

      <!--begin::Content-->
      <perfect-scrollbar class="offcanvas-content scroll"
                         style="max-height: 90vh; position: relative">
        <!--begin::Header-->
        <div class="d-flex align-items-center p-5">
          <div class="d-flex flex-column">
            <span class="font-weight-bold font-size-h5 text-dark-75">{{ $ml.get('languageSelection') }}
            </span>

            <div class="lang-buttons mt-3">
              <div v-for="lang in $ml.list"
                   :key="lang"
                   class="lang">
                <button class="btn btn-hover-light-primary rounded-sm"
                        :class="
                    $ml.current == lang
                      ? 'btn-light-primary'
                      : 'btn-light-muted'
                  "
                        @click="changeLanguage(lang)">
                  {{ $ml.get(`language_${lang}`) }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--end::Header-->

        <div class="separator separator-solid"></div>
        <div class="d-flex align-items-center p-5">
          <button class="btn btn-light-info btn-bold text-primary">
            <svg width="19"
                 height="24"
                 viewBox="0 0 19 24"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.14179 18.1214L9.14122 18.1205V23.2699C7.8862 23.0628 6.93011 22.3689 6.27296 21.1883L5.90061 21.982C4.69505 21.2582 3.75317 20.3709 3.07496 19.3201C2.39676 18.2693 1.96307 17.0083 1.7739 15.5372L0.997286 15.9713C0.332429 14.8919 0 13.5753 0 12.0214C0 10.4675 0.259733 9.12691 0.7792 7.99965C0.54762 7.85401 0.287886 7.68608 0 7.49585C0.165434 6.0464 0.892105 4.83124 2.18002 3.85038C2.08686 3.67057 1.95149 3.41912 1.7739 3.09604C2.44988 2.2079 3.41224 1.72437 4.66098 1.64543C4.6361 1.45021 4.60436 1.19785 4.56578 0.888367C5.23603 0.567824 6.46679 0.566188 7.10164 0.777497C7.22728 0.57153 7.33376 0.394297 7.42107 0.245798C7.7183 0.148813 7.99221 0.0823129 8.2428 0.0462993C8.49339 0.0102857 8.79305 -0.00471816 9.14179 0.0012876V5.62717L9.14122 5.62646V0.00128759C9.48995 -0.00471817 9.78961 0.0102857 10.0402 0.0462993C10.2908 0.0823129 10.5647 0.148813 10.8619 0.245798C10.9492 0.394297 11.0557 0.57153 11.1814 0.777497C11.8162 0.566188 13.047 0.567824 13.7172 0.888367C13.6786 1.19785 13.6469 1.45021 13.622 1.64543C14.8708 1.72437 15.8331 2.2079 16.5091 3.09604C16.3315 3.41912 16.1961 3.67057 16.103 3.85038C17.3909 4.83124 18.1176 6.0464 18.283 7.49585C17.9951 7.68608 17.7354 7.85401 17.5038 7.99965C18.0233 9.12691 18.283 10.4675 18.283 12.0214C18.283 13.5753 17.9506 14.8919 17.2857 15.9713L16.5091 15.5372C16.3199 17.0083 15.8862 18.2693 15.208 19.3201C14.5298 20.3709 13.588 21.2582 12.3824 21.982L12.01 21.1883C11.3529 22.3689 10.3968 23.0628 9.14179 23.2699L9.14151 23.27L9.14122 23.27V23.2699L9.14179 18.1214ZM9.14179 18.1214L9.57032 18.8213L9.83395 17.7092L10.1997 18.3936L10.8541 17.1958C11.0292 17.293 11.2477 17.2255 11.342 17.0452C11.3703 16.9912 11.3851 16.9308 11.3851 16.8694V16.2539C11.3851 16.069 11.2885 15.8984 11.1322 15.8073L9.95967 15.1237C9.88473 15.08 9.80007 15.0571 9.71395 15.0571H9.14179V11.7206H10.5878C10.6936 11.7206 10.7794 11.8088 10.7794 11.9177C10.7794 12.0415 10.7215 12.1577 10.6238 12.2299L9.58448 12.9982C9.50579 13.0564 9.45566 13.147 9.44723 13.2464L9.40064 13.7951C9.38912 13.9308 9.45687 14.0606 9.57315 14.1256L11.0118 14.93C11.0605 14.9572 11.1151 14.9715 11.1705 14.9715H12.0314C12.1098 14.9715 12.1857 14.943 12.2456 14.8909L12.473 14.6936C12.5479 14.6286 12.5911 14.5328 12.5911 14.432V13.4362C12.5911 13.373 12.5741 13.311 12.542 13.2572L12.0483 12.4293C12.0162 12.3754 11.9992 12.3135 11.9992 12.2503V12.1469C11.9992 12.024 12.0657 11.9114 12.1717 11.8548L13.4683 11.1626C13.5232 11.1333 13.569 11.0888 13.6007 11.0342L13.7482 10.7798C13.779 10.7268 13.7952 10.6662 13.7952 10.6044V9.69154C13.7952 9.50588 13.6933 9.33616 13.532 9.25314L13.4341 9.20275C13.3313 9.14984 13.2092 9.15535 13.1113 9.21731L12.6649 9.49985C12.5416 9.57788 12.3914 9.59691 12.2534 9.55199L11.7556 9.38997C11.568 9.32893 11.3631 9.3871 11.2325 9.53847L10.7797 10.0631L10.3636 10.0561L11.1376 9.07283C11.2954 8.87237 11.5326 8.75593 11.7833 8.75593H12.7639C12.8233 8.75593 12.8825 8.74937 12.9406 8.73636C13.3891 8.6359 13.6735 8.18019 13.5759 7.7185L13.478 7.25511C13.3117 6.46873 12.6356 5.90789 11.8538 5.90789H10.4502C10.3939 6.19825 10.2457 6.46352 10.0056 6.7037C9.8644 6.84492 9.7018 6.94423 9.51777 7.00165C9.52062 6.40373 9.3951 5.94573 9.14122 5.62717V5.62646C9.06464 5.5305 8.97639 5.44722 8.87649 5.37659C8.17211 4.8786 7.20222 5.03853 6.91886 5.25374L7.25614 5.58215L7.59069 5.90789H6.32561C5.54298 5.90789 4.86637 6.46992 4.701 7.25737L4.6004 7.73637C4.50342 8.19819 4.78848 8.6535 5.2371 8.75334C5.29481 8.76618 5.35367 8.77266 5.41271 8.77266H6.39142C6.64299 8.77266 6.88102 8.88997 7.03878 9.0917L7.81205 10.0805V10.9524L7.53412 11.4662C7.48946 11.5488 7.51828 11.653 7.59848 11.6989C7.62321 11.7131 7.65104 11.7206 7.67934 11.7206H9.09986H9.14122V15.0571H8.46827C8.3767 15.0571 8.2869 15.083 8.20871 15.1321L7.13697 15.8047C6.98849 15.8979 6.89789 16.0639 6.89789 16.243V16.876C6.89789 17.0773 7.05641 17.2404 7.25195 17.2404C7.31125 17.2404 7.3696 17.2251 7.42164 17.1958L7.914 18.3936L8.33737 17.7092L8.65506 18.8213L9.09945 18.0514L9.14179 18.1205V18.1214ZM7.39202 10.6149V10.2124L6.91237 9.58596C6.78147 9.415 6.56005 9.34762 6.35989 9.41784L6.03025 9.53348C5.89011 9.58265 5.73598 9.56516 5.6096 9.48575L5.1683 9.20846C5.07003 9.14671 4.94771 9.1417 4.84498 9.19523L4.74675 9.24641C4.58514 9.33062 4.48327 9.50123 4.48327 9.68768V10.618C4.48327 10.6792 4.49918 10.7392 4.52935 10.7919L4.67845 11.0522C4.70986 11.107 4.75551 11.1517 4.81026 11.1813L5.33098 11.4628C5.42319 11.5126 5.53276 11.5151 5.62701 11.4695L7.39202 10.6149ZM5.72567 13.2242L6.28602 12.4364C6.33372 12.3694 6.40351 12.3225 6.48234 12.3045L7.30425 12.117C7.39796 12.0957 7.49607 12.117 7.57335 12.1757L8.64853 12.9912C8.72258 13.0474 8.77071 13.1326 8.78148 13.2266L8.8451 13.7824C8.86103 13.9215 8.79294 14.0566 8.67326 14.1233L7.22742 14.9293C7.17881 14.9564 7.1244 14.9706 7.06912 14.9706H6.24518C6.16732 14.9706 6.09193 14.9425 6.03216 14.8911L5.78087 14.6752C5.7052 14.6102 5.66146 14.514 5.66146 14.4125V13.4264C5.66146 13.3537 5.68395 13.2829 5.72567 13.2242Z"
                    fill="#00BAF2" />
            </svg>
          </button>
          <a href="https://leo.plusclouds.com/"
             target="_blank"
             class="sidebar-text-black pl-3">
            {{ $ml.get('serversAndServices') }}</a>
        </div>
        <div class="separator separator-solid"></div>

        <div class="separator separator-solid"></div>
        <div class="d-flex align-items-center p-5">
          <button class="btn btn-light-info btn-bold text-primary">
            <i class="fas fa-key sidebar-icon-black"></i>
          </button>
          <router-link to="/personal-access-token"
                       class="sidebar-text-black pl-3">
            {{ $ml.get('personalAccessTokens') }}</router-link>
        </div>
        <div class="separator separator-solid"></div>

        <div class="d-flex align-items-center p-5">
          <button class="btn btn-light-danger btn-bold"
                  @click="onLogout">
            <i class="fas fa-sign-out-alt signout-icon"></i>
          </button>
          <a href="#"
             @click="onLogout"
             class="signout-text pl-3 text-danger">
            {{ $ml.get('signOut') }}</a>
        </div>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
  .lang-buttons {
    display: flex;
    align-items: center;

    span {
      margin-right: 8px;
    }

    .lang {
      margin-right: 16px;
      cursor: pointer;

      img {
        width: 32px;
      }

      &:last-child {
        margin-right: 8px;
      }
    }
  }
  #kt_quick_user_close {
    i {
      color: #f64e60 !important;
      font-size: 15px;
    }
  }
  .signout-icon {
    opacity: 0.5;
    padding: 5px 0px;
  }
  .signout-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
  }

  .btn-light-info:hover {
    background-color: #d0b6ff;
  }
  .btn.btn-light-info i {
    color: #3699ff;
  }
  .sidebar-icon {
    opacity: 0.5;
    padding: 5px 0px;
  }
  .sidebar-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
  }

  .sidebar-icon-black {
    padding: 5px 0px;
  }
  .sidebar-text-black {
    color: #6c7293;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import { LOGOUT } from '@/core/services/store/auth.module'
import KTLayoutQuickUser from '@/assets/js/layout/extended/quick-user.js'
import KTOffcanvas from '@/assets/js/components/offcanvas.js'
import EventBus from '@/event-bus'

export default {
  name: 'KTQuickUser',
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs['kt_quick_user'])
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() =>
          setTimeout(() => this.$router.push({ path: '/login' }), 1000)
        )
    },
    changeLanguage(selectedLang) {
      EventBus.$emit('changeLanguage', selectedLang)
    },
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
}
</script>